import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18c218c3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"
import style0 from "./index.vue?vue&type=style&index=0&id=18c218c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c218c3",
  null
  
)

export default component.exports